module.exports = __webpack_public_path__ + "product-bg.jpg?c4e2830ab8dcaa7a9c812c2980c9e1f3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-bg.jpg
// module id = 108
// module chunks = 0